import { Close } from './ui/close';
import { Content } from './ui/content';
import { Panel } from './ui/panel';
import { Portal } from './ui/portal';
import { Root } from './ui/root';
import { Title } from './ui/title';
import { Trigger } from './ui/trigger';

export const Dialog = {
  Root,
  Trigger,
  Portal,
  Content,
  Close,
  Title,
  Panel,
};
